<template>
    <BCard class="scip-information-section mb-1">
        <template #header>
            <div>
                <h5 class="mb-25">
                    {{ translate('Component(ResearchReviewProcess):scip-information', 'SCIP information') }}
                </h5>
                <p class="text-less-muted mb-0">
                    {{ translate(
                        'Component(ResearchReviewProcess):scip-information-description',
                        'Review the SCIP number stated at document level. It may exist even when the document does not identify a specific product.',
                    ) }}
                </p>
            </div>
        </template>

        <BFormGroup
            :label="translate('Component(Label):scip-number', 'SCIP number')"
            label-for="document-review-scip-number"
            class="mb-0"
        >
            <BFormInput
                id="document-review-scip-number"
                :value="scipNumber"
                :state="numberViolationMessages.length ? false : null"
                @input="updateScipNumber"
            />
            <BFormInvalidFeedback
                v-for="(message, index) in numberViolationMessages"
                :key="`scip-number-violation-${index}`"
                force-show
            >
                {{ message }}
            </BFormInvalidFeedback>
        </BFormGroup>
    </BCard>
</template>

<script>
import {
    BCard,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
} from 'bootstrap-vue'

export default {
    name: 'ScipInformationSection',
    components: {
        BCard,
        BFormGroup,
        BFormInput,
        BFormInvalidFeedback,
    },
    props: {
        value: {
            type: Object,
            default: null,
        },
        violations: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        scipNumber() {
            return this.value && this.value.scipNumber ? this.value.scipNumber : ''
        },
        numberViolationMessages() {
            return this.violations
                .filter(violation => violation
                    && String(violation.path || '').endsWith('[scipInformation][scipNumber]'))
                .map(violation => violation.message)
                .filter(Boolean)
        },
    },
    methods: {
        translate(key, fallback) {
            const translation = this.$t(key)
            return translation && translation !== key ? translation : fallback
        },
        updateScipNumber(value) {
            const normalized = typeof value === 'string' ? value : ''
            this.$emit('input', normalized.trim().length
                ? {
                    ...(this.value || {}),
                    scipNumber: normalized,
                }
                : null)
        },
    },
}
</script>
